import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DeviceState } from './device.reducer';

export const selectDeviceStateRoot =
  createFeatureSelector<DeviceState>('device');

export const selectIsExtraSmall = createSelector(
  selectDeviceStateRoot,
  (state) => (state ? state.isExtraSmall : false)
);

export const selectIsSmall = createSelector(selectDeviceStateRoot, (state) =>
  state ? state.isSmall : false
);

export const selectIsSmallerThanValue = (smallerThan: number) =>
  createSelector(selectDeviceStateRoot, (state) =>
    state && state.deviceWidth ? state.deviceWidth < smallerThan : false
  );

export const selectIsMedium = createSelector(selectDeviceStateRoot, (state) =>
  state ? state.isMedium : false
);

export const selectIsLarge = createSelector(selectDeviceStateRoot, (state) =>
  state ? state.isLarge : false
);

export const selectIsExtraLarge = createSelector(
  selectDeviceStateRoot,
  (state) => (state ? state.isExtraLarge : false)
);

export const selectIsLessThanSmall = createSelector(
  selectDeviceStateRoot,
  (state) => (state ? state.isLessThanSmall : false)
);

export const selectIsLessThanMedium = createSelector(
  selectDeviceStateRoot,
  (state) => (state ? state.isLessThanMedium : false)
);

export const selectIsLessThanLarge = createSelector(
  selectDeviceStateRoot,
  (state) => (state ? state.isLessThanLarge : false)
);

export const selectIsLessThanExtraLarge = createSelector(
  selectDeviceStateRoot,
  (state) => (state ? state.isLessThanExtraLarge : false)
);

export const selectIsGreaterThanExtraSmall = createSelector(
  selectDeviceStateRoot,
  (state) => (state ? state.isGreaterThanExtraSmall : false)
);

export const selectIsGreaterThanSmall = createSelector(
  selectDeviceStateRoot,
  (state) => (state ? state.isGreaterThanSmall : false)
);

export const selectIsGreaterThanMedium = createSelector(
  selectDeviceStateRoot,
  (state) => (state ? state.isGreaterThanMedium : false)
);

export const selectIsGreaterThanLarge = createSelector(
  selectDeviceStateRoot,
  (state) => (state ? state.isGreaterThanLarge : false)
);

export const selectIsLandscape = createSelector(
  selectDeviceStateRoot,
  (state) => (state ? state.isLandscape : false)
);

export const selectIsPortrait = createSelector(selectDeviceStateRoot, (state) =>
  state ? state.isPortrait : false
);

export const selectIsRetina2 = createSelector(selectDeviceStateRoot, (state) =>
  state ? state.isRetina2 : false
);

export const selectIsRetina3 = createSelector(selectDeviceStateRoot, (state) =>
  state ? state.isRetina3 : false
);

export const selectIsMobile = createSelector(selectDeviceStateRoot, (state) =>
  state ? state.isMobile : false
);

export const selectIsDesktop = createSelector(selectDeviceStateRoot, (state) =>
  state ? state.isDesktop : false
);

export const selectIsStandalone = createSelector(
  selectDeviceStateRoot,
  (state) => (state ? state.isStandalone : false)
);
